import { FormSettings } from "../../../Forms/Types/FormSettings";

import { MetricsPayload } from "./MetricsProvider";

export class MetricsCollector {
    private static readonly settings = { gfv: "", draftId: "" };

    public static setMetricsSettings(settings: FormSettings) {
        this.settings.gfv = settings.gfv;
        this.settings.draftId = settings.draftId;
    }

    public static addBasePayload(payload: MetricsPayload) {
        return { ...this.settings, ...payload };
    }
}
